import { Alert } from '@pubstack/common/src/analytics/check'
import { useQuery } from '~/api/api-client'

export const ALERT_QUERY_KEYS = ['alerts']
const url = '/checks/backlog'
//-------------------------------------------------------------------------
// Queries
//-------------------------------------------------------------------------
export const useAlerts = () => {
  return useQuery<Alert[]>({
    url,
    keys: ALERT_QUERY_KEYS,
  })
}
